import { FC, useState } from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";

import theme from "theme";

const FilterSectionTitle: FC<{
  title: string;
  HelpModal?: FC<{ onClose: () => void }>;
}> = ({ title, HelpModal }) => {
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  return (
    <>
      {HelpModal && isHelpModalOpen && (
        <HelpModal onClose={() => setIsHelpModalOpen(false)} />
      )}
      <Box display="flex" alignItems="center" marginBottom={0.5}>
        <Typography
          variant="h4"
          style={{
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightBold,
          }}
        >
          {title}
        </Typography>
        {HelpModal && (
          <Box ml={1}>
            <IconButton size="small" onClick={() => setIsHelpModalOpen(true)}>
              <InfoOutlinedIcon
                style={{
                  color: theme.palette.text.primary,
                  height: "1.125rem",
                  width: "1.125rem",
                }}
              />
            </IconButton>
          </Box>
        )}
      </Box>
    </>
  );
};

export default FilterSectionTitle;
